module.exports = __webpack_public_path__ + "img/farmer.be5030ca.webp";